module.exports = __webpack_public_path__ + "static/img/zhiye.77af799d.png";